var exports = {
  "q": "AttachmentSingleMedia.module__relativeWrapper___TW5WUE",
  "u": "AttachmentSingleMedia.module__singleMediaContainer___TW5WUE",
};

module.exports = exports;
